import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _4kIcon(props: IconProps) {
    return <Icon {...props} iconKey={"4k"}/>
}
